import { useState } from "react";
import { Box, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useAppSelector } from "Hooks/useRedux";

import useWindowSize from "Hooks/useWindowSize";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import btnImage from "Assets/Images/ic--round-double-arrow.svg";

import Map from "./Map";
import Map2 from "./Map/map2";
import Map3 from "./Map/map3";
import CarouselButtons from "./CarouselButtons";
import Supports from "./Supports";
import TrafficAnalysis from "./TrafficAnalysis";
import Reports from "./Reports";
import BehamrahShahr from "./BehamrahShahr";

export default function Home() {
  const { width, height } = useWindowSize();
  const [showBtns, setShowBtns] = useState<boolean>(false);

  const { status } = useAppSelector((state) => state.menu);
  const { page } = useAppSelector((state) => state.page);

  return (
    <>
      <div style={{ position: "relative", width: "100vw", overflow: "hidden", height: "100vh" }}>
        <div
          style={{
            position: "absolute",
            right: "34vw",
            top: showBtns ? "1.5vh" : "-6.5vh",
            zIndex: "10",
            transition: "all 0.3s ease-in-out",
          }}
        >
          {" "}
          <CarouselButtons />
        </div>

        <button
          type="button"
          onClick={() => setShowBtns(!showBtns)}
          onMouseEnter={() => setShowBtns(true)}
          style={{
            position: "absolute",
            right: "48.7vw",
            top: showBtns ? "1.9%" : "0.5%",
            zIndex: "10",
            border: "1px solid  rgb(211 208 208)",
            width: "2.6vw",
            height: "2.6vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            cursor: "pointer",
            transform: showBtns ? "rotate(-90deg)" : "rotate(90deg)",
            transition: "all 0.3s ease-in-out",
          }}
        >
          {" "}
          <img src={btnImage} alt="arrow-btn" style={{ width: "30px" }} />
        </button>

        <div style={{ position: "absolute", right: `${100 - page * 100}%`, transition: "all ease-in-out 0.5s" }}>
          <Box sx={{ width, height, position: "relative", overflow: "hidden" }}>
            <Reports />
          </Box>
        </div>

        <div style={{ position: "absolute", right: `${200 - page * 100}%`, transition: "all ease-in-out 0.5s" }}>
          <Box sx={{ width, height, position: "relative", overflow: "hidden" }}>
            <Map2 />
            {page === 2 ? <Supports /> : null}
          </Box>
        </div>

        <div style={{ position: "absolute", right: `${300 - page * 100}%`, transition: "all ease-in-out 0.5s" }}>
          <Box sx={{ width, height, position: "relative", overflow: "hidden" }}>
            <Map3 />
            {page === 3 ? <TrafficAnalysis /> : null}
          </Box>
        </div>

        <div style={{ position: "absolute", right: `${400 - page * 100}%`, transition: "all ease-in-out 0.5s" }}>
          <Box sx={{ width, height, position: "relative", overflow: "hidden" }}>
            <Map />
            {page === 4 ? <BehamrahShahr /> : null}
          </Box>
        </div>

        {/* <div style={{ position: "absolute", right: `${300 - page * 100}%`, transition: "all ease-in-out 0.5s" }}>
          <Box sx={{ width, height, position: "relative", overflow: "hidden" }}>
            <Map />

            {selectLocMode === 1 || selectLocMode === 2 ? (
              <>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ position: "absolute", top: "45vh", right: "48.5vw", pointerEvents: "none" }}
                >
                  <Pin />
                </Stack>
              </>
            ) : null}
            {selectLocFor === "add-survay" && selectLocMode > 0 && selectLocMode < 4 ? (
              <>
                <Stack direction="row" spacing={1} sx={{ width: "100%", position: "absolute", bottom: "100px" }}>
                  <AddSurvay />
                </Stack>
              </>
            ) : null}
            {selectLocFor === "add-station" && selectLocMode > 0 && selectLocMode < 3 ? (
              <>
                <Stack direction="row" spacing={1} sx={{ width: "100%", position: "absolute", bottom: "100px" }}>
                  <AddStation />
                </Stack>
              </>
            ) : null}
            <Stack
              direction="row"
              spacing={1}
              sx={{ width: "30%", position: "absolute", top: LAYOUT_MARGIN, left: "55%" }}
            ></Stack>
            <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
              <Operation />
              <SortStations />
              <ShowPaths />
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: fullScreen ? 2 : LAYOUT_MARGIN + 56,
                right: LAYOUT_MARGIN,
                width: fullScreen ? `calc(100% - ${LAYOUT_MARGIN * 2}px)` : "400px",
                zIndex: fullScreen ? "1001" : "",
                transition: "all 0.3s",
              }}
            >
              <SimpleDashboard />
            </Box>

            <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, right: LAYOUT_MARGIN }}>
              <LocationData />
            </Box>

            <Box sx={{ position: "absolute", top: "50%", right: 0, transform: "translateY(-50%)", zIndex: 1000 }}>
              <Menu />
            </Box>
            {surveyShowType === 0 && surveysVisible && !pointwiseShow ? (
              <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
                <Spectrum3 />
              </Stack>
            ) : null}
            {surveyShowType === 1 && surveysVisible ? (
              <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
                <Spectrum2 />
              </Stack>
            ) : null}
            {surveyShowType === 2 && surveysVisible ? (
              <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
                <Spectrum />
              </Stack>
            ) : null}
            <Stack
              direction="row"
              spacing={1}
              sx={{
                width: `calc(100% - ${LAYOUT_MARGIN * 2}px)`,
                position: "absolute",
                bottom: LAYOUT_MARGIN,
                left: LAYOUT_MARGIN,
              }}
            >
              <Tooltip bgcolor="green" />
              <Toolbox />
            </Stack>
            <Modals />
          </Box>
        </div> */}
      </div>
    </>
  );
}
